var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_337_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.976 19.392C20.976 14.256 25.152 10.08 30.288 10.08H37.92V16.848H30.288C28.896 16.848 27.744 18 27.744 19.392V20.256H34.512V27.024H27.744V29.568C27.744 34.704 23.568 38.88 18.432 38.88C13.296 38.88 9.12002 34.704 9.12002 29.568C9.12002 24.432 13.296 20.256 18.432 20.256L20.976 20.256V19.392V19.392ZM48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24Z",
    fill: "#00EF8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.744 20.2559H20.9761V27.0238H27.744V20.2559Z",
    fill: "#00EF8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9761 27.0239H18.4321C17.0401 27.0239 15.8881 28.1759 15.8881 29.5679C15.8881 30.9599 17.0401 32.1119 18.4321 32.1119C19.8241 32.1119 20.9761 30.9599 20.9761 29.5679V27.0239Z",
    fill: "#00EF8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_337_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.23f81dfd47711577c3c09f60a80a2089.svg";
export { ForwardRef as ReactComponent };